<div class="pb-4">

  <div class="container text-center min-width p-0">

    <!-- Breadcrumb -->
    <div class="row p-0 m-0">
      <div class="col-lg-12 col-md-12 col-sm-12 text-start">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb" style="margin-bottom: 0.5rem;">
            <li class="breadcrumb-item">
              <a (click)="routerLink('home')" class="text-padrao"><i class="bi bi-grid position-relative"></i> Dashboard</a>
            </li>
            <li class="breadcrumb-item">
              <a (click)="routerLink('tipos')" class="text-padrao">Tipos</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Adicionar</li>
          </ol>
        </nav>
      </div>

      <div class="col-12 text-start">
        <button type="button" class="btn btn-outline-secondary mb-2" (click)="routerLink('tipos')" style="display: flex; justify-content: space-around;">
          <i class="bi bi-arrow-left"></i>
          Voltar
        </button>
      </div>
    </div>


    <!-- Tipo -->
    <div class="row p-0 m-0">
      <div class="row p-0 m-0">
        <div class="min-width col-lg mb-3">
          <div class="box-gen-card">
            <div class="row p-0 m-0">
              <div class="col-lg-12 reset-padding-mobile">
                <h3 class="p-0 m-0 text-cor-padrao text-start w-100">
                  Novo Tipo
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tipo Dados -->
      <div class="min-width col-lg-12 pb-3">
        <div class="p-0 m-0 box-gen-card">
          <div class="row p-0 m-0">
            <!-- tipo.nome -->
            <div class="col-lg-12 reset-padding-mobile">
              <div style="display: flex;flex-direction: row;align-items: center;flex-wrap: nowrap;justify-content: space-between;margin-top: 5px;">
                <app-ag-input-field class="w-100"
                  [(ngModel)]="tipo.nome.valor"
                  [label]="tipo.nome.title"
                  [tooltip]="tipo.nome.info"
                  [value]="tipo.nome.valor"
                  [isInvalid]="tipo.nome.status?.invalid"
                  [AgStatus]="tipo.nome.status"
                  [id]="'tipo_nome'"
                  AgPlaceholder="{{tipo.nome.placeholder}}"
                  AgInputType="{{tipo.nome.inputType}}"
                  AgMaxlength="{{tipo.nome.maxlength}}"
                  AgInputMode="{{tipo.nome.inputMode}}"
                  (ngModelChange)="tipo.mascara(tipo.nome.mascara, 'nome');"
                  (change)="tipo.validarInput('nome');"
                  >
                </app-ag-input-field>
              </div>
            </div>

            <!-- tipo.descricao -->
            <div class="col-lg-12 reset-padding-mobile">
              <div style="display: flex;flex-direction: row;align-items: center;flex-wrap: nowrap;justify-content: space-between;margin-top: 5px;">
                <app-ag-textarea-field class="w-100"
                  [(ngModel)]="tipo.descricao.valor"
                  [label]="tipo.descricao.title"
                  [tooltip]="tipo.descricao.info"
                  [value]="tipo.descricao.valor"
                  [isInvalid]="tipo.descricao.status?.invalid"
                  [AgStatus]="tipo.descricao.status"
                  [id]="'tipo_descricao'"
                  AgPlaceholder="{{tipo.descricao.placeholder}}"
                  AgInputType="{{tipo.descricao.inputType}}"
                  AgMaxlength="{{tipo.descricao.maxlength}}"
                  AgInputMode="{{tipo.descricao.inputMode}}"
                  (ngModelChange)="tipo.mascara(tipo.descricao.mascara, 'descricao');"
                  (change)="tipo.validarInput('descricao');"
                  >
                </app-ag-textarea-field>
              </div>
            </div>

            <!-- tipo.status -->
            <div class="col-lg-12 reset-padding-mobile">
              <app-ag-mat-checkbox
                [(ngModel)]="tipo.status.valor"
                [label]="tipo.status.title"
                [tooltip]="tipo.status.info"
                [value]="tipo.status.valor"
                [id]="'tipo_status'"
                >
              </app-ag-mat-checkbox>
            </div>

          </div>
        </div>
      </div>

      <!-- Ação Criar / Cancelar -->
      <div class="min-width col-lg-12 pb-3">
        <div class="p-0 m-0 box-gen-card" style=" background: transparent; box-shadow: none; border: none; ">

          <!-- <div class="w-100 mb-3" style="text-align: left; display: flex; align-items: center; ">
            <mat-checkbox [(ngModel)]="agenda.status.valor" [color]="'radial-primary'">
              {{agenda.status.title}}
            </mat-checkbox>
            <span mat-raised-button #status="matTooltip" [matTooltip]="agenda.status.info" matTooltipPosition="right" (click)="status.show()" class="tooltip-input-icon">
              <i class="bi bi-info-circle-fill"></i>
            </span>
          </div> -->

          <div class="mt-2 d-flex justify-content-between align-items-center flex-nowrap">
            <button type="button" class="btn btn-primary w-50" style="color: #fff;margin-right: 5px;padding: 15px !important;" (click)="criarTipo()">Criar Tipo</button>
            <button type="button" class="btn btn-outline-danger w-50" (click)="routerLink('tipos')" style="padding: 15px !important;">Cancelar</button>
          </div>
        </div>
      </div>
    </div>


  </div>
</div>

<!-- alert Tipo Modal -->
<div class="modal" id="alertTipoModal" #alertTipoModal data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title p-0 m-0">Atenção</h4>
        <span id="btn-close-x-foto" class="text-cor-padrao" data-bs-dismiss="modal" style="padding: 0px 0px;font-size: 20px;cursor: pointer;">
          <i class="bi bi-x-circle-fill" style="cursor: pointer;"></i>
        </span>
      </div>

      <!-- Modal body -->
      <div class="modal-body p-0 m-0" >
        <div style="padding: 0px 15px;">
          <h4 class="modal-title pt-3 pb-2 p-0 m-0 text-start">Alguns campos precisam ser preenchidos</h4>
        </div>

        <div style=" padding: 15px; ">

          <div *ngIf="tipo.nome.status.invalid" class="border-danger gen-card">
            <p class="text-cor-padrao gen-card-title">{{ tipo.nome.title }}</p>
            <p class="text-cor-padrao gen-card-info">{{ tipo.nome.info }}</p>
          </div>

          <div *ngIf="tipo.descricao.status.invalid" class="border-danger gen-card">
            <p class="text-cor-padrao gen-card-title">{{ tipo.descricao.title }}</p>
            <p class="text-cor-padrao gen-card-info">{{ tipo.descricao.info }}</p>
          </div>

        </div>

      </div>

      <!-- Modal footer -->
      <div class="modal-footer d-flex justify-content-end align-items-start">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Ok</button>
        <!-- <button type="button" class="btn btn-danger"  style="color: #fff;">Deletar</button> -->
      </div>

    </div>
  </div>
</div>
